import { render, staticRenderFns } from "./CustomerSavedCards.vue?vue&type=template&id=dc6a52d0&"
import script from "./CustomerSavedCards.vue?vue&type=script&lang=js&"
export * from "./CustomerSavedCards.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSavedCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports